/**
*  @class
*  @function DataLayer
*/
class DataLayer extends HTMLElement {
    constructor() {
        super();
    }

    addItemToCart(parsedState) {
        let cart_total = 0;
        let dataLayerItems = []
        parsedState.items.forEach((item, i) => {
            let price = 0;
            if (item.price > 0) {
                price = (item.price / 100);
                cart_total += price * item.quantity;
            }

            dataLayerItems.push(
                {
                    item_id: item.variant_id,
                    item_name: item.product_title,
                    affiliation: 'Online Store',
                    coupon: "",
                    discount: item.total_discount,
                    index: i,
                    item_brand: item.vendor,
                    item_category: item.product_type,
                    item_variant: item.variant_title,
                    location_id: item.url,
                    item_list_id: item.product_id,
                    price: price,
                    quantity: item.quantity
                }
            );
        });
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
                currency: 'USD',
                value: cart_total,
                items: dataLayerItems
            }
        });
    }

    removeItemFromCart(parsedState) {
        let cart_total = 0;
        let dataLayerItems = []
        parsedState.items.forEach((item, i) => {
            let price = 0;
            if (item.price > 0) {
                price = (item.price / 100);
                cart_total += price * item.quantity;
            }

            dataLayerItems.push(
                {
                    item_id: item.variant_id,
                    item_name: item.product_title,
                    affiliation: 'Online Store',
                    coupon: "",
                    discount: item.total_discount,
                    index: i,
                    item_brand: item.vendor,
                    item_category: item.product_type,
                    item_variant: item.variant_title,
                    location_id: item.url,
                    item_list_id: item.product_id,
                    price: price,
                    quantity: item.quantity
                }
            );
        });
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'remove_from_cart',
            ecommerce: {
                currency: 'USD',
                value: cart_total,
                items: dataLayerItems
            }
        });
    }

    productImpression(product, variant, location) {
        let price = 0;
        if (variant.price > 0) {
            price = (variant.price / 100);
        }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'view_item',
            ecommerce: {
                currency: 'USD',
                value: price,
                items: [{
                    item_id: variant.id,
                    item_name: product.title,
                    affiliation: 'Online Store',
                    coupon: "",
                    index: 0,
                    item_brand: product.vendor,
                    item_category: product.type,
                    item_variant: variant.title,
                    location_id: location,
                    item_list_id: product.id,
                    price: price,
                    // quantity: item.quantity
                }]
            }
        });
    }

    viewItems(products) {
        let dataLayerItems = []
        products.forEach((product, i) => {
            let price = 0;
            if (product.price > 0) {
                price = (product.price / 100);
            }

            dataLayerItems.push(
                {
                    item_name: product.title,
                    affiliation: 'Online Store',
                    index: i,
                    item_brand: product.vendor,
                    item_category: product.type,
                    item_list_id: product.id,
                    price: price,
                }
            );
        });
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'view_item_list',
            ecommerce: {
                currency: 'USD',
                items: dataLayerItems
            }
        });
    }

    viewCart(data) {
        let dataLayerItems = [];
        
        data.items.forEach((product, i) => {
            let price = 0;
            if (product.price > 0) {
                price = (product.price / 100);
            }

            dataLayerItems.push({
                item_id: product.id,
                item_name: product.product_title,
                affiliation: 'Online Store',
                index: i,
                item_brand: product.vendor,
                item_category: product.product_type,
                item_variant: product.variant_title,
                item_list_id: product.product_id,
                price: price,
                quantity: product.quantity
            });
        });
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'view_cart',
            ecommerce: {
                currency: 'USD',
                items: dataLayerItems
            }
        });
    }
}
customElements.define('data-layer', DataLayer);